var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBow1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.293 8.46447C11.6835 8.07394 12.3167 8.07394 12.7072 8.46447L15.5356 11.2929C15.9262 11.6834 15.9262 12.3166 15.5356 12.7071L12.7072 15.5355C12.3167 15.9261 11.6835 15.9261 11.293 15.5355L8.46453 12.7071C8.074 12.3166 8.074 11.6834 8.46453 11.2929L11.293 8.46447Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.5335 6.71504C11.0568 6.80513 10.6012 7.03466 10.2322 7.40362L7.4038 10.232C7.03478 10.6011 6.80524 11.0568 6.71518 11.5336L3.31911 10.2274C1.92992 9.69312 1.55064 7.90585 2.60309 6.8534L6.8534 2.60309C7.90585 1.55064 9.69312 1.92992 10.2274 3.31911L11.5335 6.71504Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.4663 17.2846C12.9431 17.1945 13.3988 16.965 13.7678 16.596L16.5962 13.7676C16.9651 13.3986 17.1946 12.9431 17.2847 12.4664L20.6809 13.7726C22.0701 14.3069 22.4494 16.0941 21.3969 17.1466L17.1466 21.3969C16.0942 22.4494 14.3069 22.0701 13.7726 20.6809L12.4663 17.2846Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBow1);
export default __webpack_public_path__ + "static/media/bow-1.50f86e495afc333166e650eb68d1bdce.svg";
export { ForwardRef as ReactComponent };